import { IonIcon } from "@ionic/react";
import { logoDropbox } from "ionicons/icons";
import React from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

const NoProductsFound = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="flex flex-col justify-center items-center gap-2.5">
      <IonIcon icon={logoDropbox} className="text-4xl h-24 w-24 text-gray-600" />
      <p className="text-xl text-gray-600">{t("No Products Found!")}</p>
      <button className="px-4 py-2 rounded-3xl bg-gray-600 text-white" onClick={handleGoBack}>
        {t("Go Back")}
      </button>
    </div>
  );
};

export default NoProductsFound;
